import { TechMultiplePlatformItemTypes } from "../../../utility/types/generaTypes";
import GradientIcon from "../gradientIcon/GradientIcon";
import "./TechMultiplePlatformCard.css";

type TechMultiplePlatformCardProps = {
  TechMultiplePlatform: TechMultiplePlatformItemTypes;
};
const TechMultiplePlatformCard = ({
  TechMultiplePlatform,
}: TechMultiplePlatformCardProps) => {
  return (
    <div
      className="techMultiplePlatformCard_container"
      style={{
        border:
          TechMultiplePlatform.type === "Native Performance"
            ? "1px solid #ededed"
            : "2px solid #d9e1f8",
      }}
    >
      <GradientIcon
        src={TechMultiplePlatform?.icon}
        alt={TechMultiplePlatform?.title + "_icon"}
        mainContainerClassName={"techMultiplePlatformCard_img_container"}
      />
      <p className="techMultiplePlatformCard_title">
        {TechMultiplePlatform?.title}
      </p>
      <p className="techMultiplePlatformCard_description">
        {TechMultiplePlatform?.description}
      </p>
      <div
        className={`techMultiplePlatformCardType ${
          TechMultiplePlatform.type === "Shared Logic" && "gradient_bg"
        }`}
      >
        <p
          style={{
            color:
              TechMultiplePlatform.type === "Shared Logic"
                ? "#fff"
                : "hsl(214 84% 56%)",
          }}
        >
          {TechMultiplePlatform.type}
        </p>
      </div>
    </div>
  );
};

export default TechMultiplePlatformCard;
